import multiguard from 'vue-router-multiguard';
import { checkAuth } from '@/router/_auth';

export default {
	path: '/forms',
	name: 'forms',
	redirect: { name: 'formsBes' },
	meta: {
		title: 'Bireysel Emeklilik Formlar',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth]),
	component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/Home.vue'),
	children: [
		{
			path: 'bes',
			name: 'formsBes',
			redirect: { name: 'besRequestForms' },
			meta: {
				title: 'Bireysel Emeklilik',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/bes/Home.vue'),
			children: [
				{
					path: 'request-forms',
					name: 'besRequestForms',
					meta: {
						title: 'Talep Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/bes/RequestForms.vue'),
				},
				{
					path: 'information-forms',
					name: 'besInformationForms',
					meta: {
						title: 'Bilgi/Beyan Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/bes/InformationForms.vue'),
				},
				{
					path: 'change-forms',
					name: 'besChangeForms',
					meta: {
						title: 'Değişiklik Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/bes/ChangeForms.vue'),
				},
				{
					path: 'related-forms',
					name: 'besRelatedForms',
					meta: {
						title: 'İlgili Belgeler',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/bes/RelatedForms.vue'),
				}
			]
		},
		{
			path: 'auto-attendance',
			name: 'autoAttendance',
			redirect: { name: 'autoAttendanceRequestForms' },
			meta: {
				title: 'Otomatik Katılım',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/auto/Home.vue'),
			children: [
				{
					path: 'request-forms',
					name: 'autoAttendanceRequestForms',
					meta: {
						title: 'Talep Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/auto/RequestForms.vue'),
				},
				{
					path: 'change-forms',
					name: 'autoAttendanceChangeForms',
					meta: {
						title: 'Değişiklik Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/auto/ChangeForms.vue'),
				},
				{
					path: 'related-forms',
					name: 'autoAttendanceRelatedForms',
					meta: {
						title: 'İlgili Belgeler',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/auto/RelatedForms.vue'),
				}
			]
		},
		{
			path: 'life',
			name: 'formsLife',
			redirect: { name: 'lifeRequestForms' },
			meta: {
				title: 'Hayat Sigortaları',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/life/Home.vue'),
			children: [
				{
					path: 'request-forms',
					name: 'lifeRequestForms',
					meta: {
						title: 'Talep Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/life/RequestForms.vue'),
				},
				{
					path: 'information-forms',
					name: 'lifeInformationForms',
					meta: {
						title: 'Bilgi/Beyan Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/life/InformationForms.vue'),
				},
				{
					path: 'change-forms',
					name: 'lifeChangeForms',
					meta: {
						title: 'Değişiklik Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/life/ChangeForms.vue'),
				},
				{
					path: 'related-forms',
					name: 'lifeRelatedForms',
					meta: {
						title: 'İlgili Belgeler',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/life/RelatedForms.vue'),
				}
			]
		},
		{
			path: 'health',
			name: 'formsHealth',
			redirect: { name: 'healthRequestForms' },
			meta: {
				title: 'Sağlık Sigortaları',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/health/Home.vue'),
			children: [
				{
					path: 'request-forms',
					name: 'healthRequestForms',
					meta: {
						title: 'Talep Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/health/RequestForms.vue'),
				},
				{
					path: 'information-forms',
					name: 'healthInformationForms',
					meta: {
						title: 'Bilgi/Beyan Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/health/InformationForms.vue'),
				},
				{
					path: 'change-forms',
					name: 'healthChangeForms',
					meta: {
						title: 'Değişiklik Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/health/ChangeForms.vue'),
				},
				{
					path: 'related-forms',
					name: 'healthRelatedForms',
					meta: {
						title: 'İlgili Belgeler',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/health/RelatedForms.vue'),
				}
				
			
			]
		},
		{
			path: 'personal-accident',
			name: 'formsPersonalAccident',
			redirect: { name: 'personalAccidentRequestForms' },
			meta: {
				title: 'Ferdi Kaza Sigortaları',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/personal-accident/Home.vue'),
			children: [
				{
					path: 'request-forms',
					name: 'personalAccidentRequestForms',
					meta: {
						title: 'Talep Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/personal-accident/RequestForms.vue'),
				},
				{
					path: 'information-forms',
					name: 'personalAccidentInformationForms',
					meta: {
						title: 'Bilgi/Beyan Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/personal-accident/InformationForms.vue'),
				},
				{
					path: 'change-forms',
					name: 'personalAccidentChangeForms',
					meta: {
						title: 'Değişiklik Formları',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/personal-accident/ChangeForms.vue'),
				},
				{
					path: 'related-forms',
					name: 'personalAccidentRelatedForms',
					meta: {
						title: 'İlgili Belgeler',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/forms/personal-accident/RelatedForms.vue'),
				}
			
				
			]
		}
	]
}